import { LAYER_HEIGHT_WITH_BORDER, LAYER_BORDER } from '~/constant'

export function snapToLayer({ layerIndex, timelineScrollTop }) {
  const snappedY = (layerIndex * LAYER_HEIGHT_WITH_BORDER) + LAYER_BORDER - timelineScrollTop
  return snappedY
}
